import { AuthUserService } from 'app/shared/services/userServices/auth-user.service';
import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormControl, Validators, FormBuilder, AbstractControl, ValidatorFn } from '@angular/forms';

// import custom validator to validate that password and confirm password fields match
import { MustMatch } from '../../../shared/directives/must-match.validator';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { IResponse } from 'app/shared/interfaces/response.interface';
import { LookupService } from 'app/shared/services/lookupServices/lookup.service';
import { HelperService } from 'app/shared/services/helper.service';

@Component({
    selector: 'app-register-page',
    templateUrl: './register-page.component.html',
    styleUrls: ['./register-page.component.scss']
})

export class RegisterPageComponent implements OnInit {
    registerFormSubmitted = false;
    registerForm: FormGroup;
    getSchoolForm: FormGroup;
    tabs = ['First', 'Second', 'Third'];
    selected = new FormControl(0);
    universities = [];
    collages = [];
    cities = [];
    currentIndex = 0;

    postgraduates = [
        { name: ' دبلومة مهنية', id: 1 },
        { name: ' ماجستير', id: 2 },
        { name: ' دكتوراة', id: 3 },

    ];

    occupationList = [];

    yearsExperinceList = [
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 },
        { name: '7', value: 7 },
        { name: '8', value: 8 },
        { name: '9', value: 9 },
        { name: '10', value: 10 },
        { name: 'اكثر من 10', value: 11 },
    ];

    uploadedFile: any;
    public fileData: any = null;
    fileChanged = false;
    urls = [];
    showPasswordText = false;

    genderList = [
        { name: 'ذكر', value: 1 },
        { name: 'أنثي', value: 2 },
    ];

    governorateList: any[] = [];
    districtList: any[] = [];
    schoolsList: any[] = [];
    subjectList: any[] = [];
    stageList: any[] = [];
    allGradeList: any[] = [];
    gradeList: any[] = [];

    completeProfile = false;
    teacherName: any;
    teacherEmail: any;
    attachments: any = [];
    attachmentList: any = [];
    attachmentsInvalid = true;

    SchoolForm = {
        govId: null,
        disId: null,
        schoolId: null,
        subjects: null,
    };

    constructor(private fb: FormBuilder,
        private sanitizer: DomSanitizer,
        private router: Router,
        private lookupService: LookupService,
        public auth: AuthUserService,
        private helper: HelperService
    ) { }

    ngOnInit(): void {
        let email = localStorage.getItem('email');
        let name = localStorage.getItem('fullName');
        let user_authenticated = localStorage.getItem('user_authenticated');

        if (user_authenticated == 'false') {
            this.completeProfile = true;
            this.teacherEmail = email;
            this.teacherName = name;
        }

        if (user_authenticated == 'true') {
            this.router.navigate(['/pages/login']);
        }

        this.buildForm();

        this.f.govId.valueChanges.subscribe(value => {
            this.f.disId.setValue(null);
        });

        this.f.disId.valueChanges.subscribe(value => {
            this.f.schoolId.setValue(null);
        });

        this.f.schoolId.valueChanges.subscribe(value => {
            this.f.stages.setValue(null);
        });

        this.f.stages.valueChanges.subscribe(value => {
            this.gradeList = [];
            let List = [];

            if (value) {
                value.map(item => {
                    List.push(this.allGradeList.filter(el => el.stage == item)[0]);
                });

                List.map(el => {
                    el.list.map(item => {
                        this.gradeList.push(item);
                    });
                });
            }

            this.f.grades.setValue(null);
        });

        this.f.grades.valueChanges.subscribe(value => {
            value ? this.subjectList = [] : this.subjectList = [];
            this.f.subjects.setValue(null);
        });
    }

    get f() {
        return this.getSchoolForm.controls;
    }

    buildForm(): void {
        this.registerForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            nationalId: [null, [
                Validators.required,
                Validators.pattern(/^[0-9]{14}$/),
            ]],
            phoneNumber: [null, [
                Validators.required,
                Validators.pattern(/^1[0-2,5]{1}[0-9]{8}$/),
            ]],
            gender: [null, Validators.required],
            birthdate: [null, [
                Validators.required,
                this.dateRangeValidator
            ]],
            password: [null, [Validators.required, Validators.minLength(8),
            Validators.pattern(
                /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$-\/:-?{-~!"^_`\[\]@%$*])(?=.{8,})/
            )]],
            confirmPassword: [null, Validators.required],
            address: [null, Validators.required],
        },
            {
                validators: this.checkPasswords
            }
        );

        this.getSchoolForm = this.fb.group({
            govId: [null, Validators.required],
            disId: [null, Validators.required],
            schoolId: [null, Validators.required],
            subjects: [null, Validators.required],
            stages: [null, Validators.required],
            grades: [null, Validators.required],
            university: [null, Validators.required],
            college: [null, Validators.required],
            postgraduate: [null, Validators.required],
            occupationId: [null, Validators.required],
            academicApproach: [null, Validators.required],
            areaOfInteresetCityId: [null]
        });

        if (this.completeProfile) {
            this.registerForm.get('name').setValue(this.teacherName);
            this.registerForm.get('email').setValue(this.teacherEmail);
            this.registerForm.get('password').setValidators(null);
            this.registerForm.get('confirmPassword').setValidators(null);
            this.registerForm.updateValueAndValidity();
        }
    }

    get rf() {
        return this.registerForm.controls;
    }

    private dateRangeValidator: ValidatorFn = (): {
        [key: string]: any;
    } | null => {
        let invalid = false;
        const birthdate = this.registerForm && this.registerForm.get("birthdate").value;

        if (birthdate) {
            invalid = new Date(birthdate).getFullYear() > new Date().getFullYear() - 18 || new Date(birthdate).getFullYear() < new Date().getFullYear() - 100;
        }

        return invalid ? { invalidDate: { birthdate } } : null;
    };

    checkPasswords(control: AbstractControl) {
        // here we have the 'passwords' group
        const password = control.get('password').value;
        const confirmPassword = control.get('confirmPassword').value;
        const confirmPasswordErrors = control.get('confirmPassword').errors;

        if (confirmPasswordErrors && !confirmPasswordErrors.notSame) return;
        else if (password !== confirmPassword) {
            control.get('confirmPassword').setErrors({ notSame: true });
        } else {
            control.get('confirmPassword').setErrors(null);
        }
    }

    getIndex(index) {
      this.currentIndex = index;
    }

    // upload
    uploadFile($event, index, size?) {
        this.fileData = $event.target.files[0];

        if ((this.fileData.size / 1024) <= size) {
            this.fileChanged = true;
            this.uploadedFile = true;

            this.attachments[index].url = this.sanitizer.bypassSecurityTrustUrl(
                URL.createObjectURL(this.fileData)
            );

            this.attachments[index].src = this.fileData;
        } else {
            this.helper.alertError(`هذا الملف يجيب ان يكون اقل من${(size / 1024).toFixed(2)} ميجا`);
        }

        this.checkAttachments();
    }

    clearFile(i) {
        this.attachments[i].url = null;
        this.attachments[i].src = null;
        this.checkAttachments();
    }

    checkAttachments() {
        this.attachmentsInvalid = this.attachments.some(el => el.required ? el.src == null : false);
        this.attachmentList = [];
        this.attachments.map(el => {
            this.attachmentList.push({
                Id: el.id,
                Src: el.src
            });
        });
    }

    //  On submit click, reset field value
    async onSubmit(isSubmited) {
      console.log('selected',this.currentIndex);
        try {
            this.registerFormSubmitted = true;
            if (this.registerForm.invalid) return;

            let body = {
                email: this.registerForm.get('email')?.value,
                fullName: this.registerForm.get('name')?.value,
                phoneNumber: this.registerForm.get('phoneNumber')?.value,
                password: this.registerForm.get('password')?.value,
                displayName: this.registerForm.get('name')?.value,
                nationalId: this.registerForm.get('nationalId')?.value,
                gender: this.registerForm.get('gender')?.value,
                birthDate: this.registerForm.get('birthdate')?.value,
                address: this.registerForm.get('name')?.value,
                schoolId: this.getSchoolForm.get('schoolId')?.value,
                subjects: this.getSchoolForm.get('subjects')?.value ?? [],
                grades: this.getSchoolForm.get('grades')?.value ?? [],
                universityId: this.getSchoolForm.get('university')?.value,
                college: this.getSchoolForm.get('college')?.value,
                postgraduate: this.getSchoolForm.get('postgraduate')?.value,
                occupationId: this.getSchoolForm.get('occupationId')?.value,
                areaOfInteresetCityId: this.getSchoolForm.get('areaOfInteresetCityId')?.value,
                userType: +localStorage.getItem('type'),
                isDeleted: !isSubmited
            };

            let formData = new FormData();
            formData = this.helper.jsonToFormData(body);

            for (let index = 0; index < this.attachmentList.length; index++) {
                formData.append(`Attachements[${index}].Id`, this.attachmentList[index].Id);
                formData.append(`Attachements[${index}].Src`, this.attachmentList[index].Src);
            }

            if (this.completeProfile) {
                const res: IResponse = await this.auth.completeProfile(formData);

                if (res && res.success) {
                    this.helper.alertSuccess(res.arabicMessage);
                    localStorage.clear();
                    this.auth.saveUserData(res.returnObject, true);
                    this.router.navigateByUrl('/page/dashboard');
                    // if(this.auth.hasApprovedApplications())
                    //   this.router.navigateByUrl('/page/session/today');
                    // else
                    //   this.router.navigateByUrl('/page/requests');
                } else {
                    this.helper.alertError(res.arabicMessage);
                }
            } else {
              if(localStorage.getItem('email') == this.registerForm.get('email')?.value && this.currentIndex == 0) {
                this.selected.setValue(this.selected.value + 1);
              } else if(localStorage.getItem('teacherDetails') ==  JSON.stringify(this.getSchoolForm.value) && this.currentIndex == 1) {
                this.selected.setValue(this.selected.value + 1);
              }  else{
                const res: IResponse = await this.auth.register(formData);

                if (res && res.success) {
                    console.log(res);
                    //Todo -- Cache returned teacher email (res.returnObject.Email).
                    localStorage.setItem('email', res.returnObject.email);
                    if(this.currentIndex == 1){
                    localStorage.setItem('teacherDetails', JSON.stringify(this.getSchoolForm.value));
                    }
                    if (res.returnObject.isDeleted)
                        this.selected.setValue(this.selected.value + 1);
                    else {
                        this.helper.alertSuccess(res.arabicMessage);
                        localStorage.removeItem('teacherDetails');
                        localStorage.removeItem('email');
                        this.router.navigate(['/pages/login']);
                    }
                } else {
                    this.helper.alertError(res.arabicMessage);
                }
               }
            }
        } catch (err) {
            if (err.status != 401)
                this.helper.alertError("حدث خطأ ما برجاء المحاولة مرة اخرى");
        }
    }

    showPassword() {
        this.showPasswordText = !this.showPasswordText;
    }
}
